// src/pages/PolitiqueConfidentialitePage.js
import React from 'react';
import './PolitiqueConfidentialitePage.css'; // Ou importe MentionsLegalesPage.css si les styles sont partagés

function PolitiqueConfidentialitePage() {
  return (
    <div className="container privacy-policy-page-container"> {/* Adapte la classe si tu partages le CSS */}
      <h1>Politique de Confidentialité</h1>

      <section className="privacy-section">
        <p>
          <strong>Introduction</strong>
          <br />
          **Info Colab**, responsable du traitement, s’engage à protéger la vie privée des utilisateurs de son site web **infocolab.com**. Cette politique de confidentialité explique quelles données personnelles nous collectons, comment nous les utilisons, les partageons et les protégeons.
        </p>
      </section>

      <section className="privacy-section">
        <h2>1. Responsable du traitement des données</h2>
        <p>
          <strong>Nom :</strong> Info Colab
          <br />
          <strong>Adresse :</strong> 8 Rue de l'Eglise, 78440 Drocourt, France
          <br />
          <strong>Email :</strong> contact@infocolab.com
          <br />
          <strong>Téléphone :</strong> +33 7 69 29 79 63
        </p>
      </section>

      <section className="privacy-section">
        <h2>2. Données personnelles collectées</h2>
        <p>Nous pouvons collecter et traiter les données suivantes :</p>
        <ul>
          <li>
            <strong>Données que vous nous fournissez directement :</strong>
            <ul>
              <li>Lorsque vous remplissez notre formulaire de contact : nom, prénom, adresse e-mail, numéro de téléphone (optionnel), sujet et contenu de votre message.</li>
              {/* Ajoutez d'autres cas si Info Colab propose d'autres formulaires ou interactions */}
            </ul>
          </li>
          <li>
            <strong>Données collectées automatiquement :</strong>
            <ul>
              <li>Lorsque vous naviguez sur notre site : adresse IP, type et version du navigateur, pages visitées, temps passé sur chaque page, date et heure de la visite, données de parcours de navigation. Ces données sont collectées via des cookies et technologies similaires (voir section "Cookies").</li>
              {/* Préciser si vous utilisez des outils d'analyse comme Google Analytics et ce qu'ils collectent */}
            </ul>
          </li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>3. Finalités du traitement des données</h2>
        <p>Vos données personnelles sont collectées et traitées pour les finalités suivantes :</p>
        <ul>
          <li>Répondre à vos demandes de contact et de devis.</li>
          <li>Fournir et gérer les services que vous nous commandez.</li>
          <li>Améliorer notre site web et nos services (analyse de l'utilisation).</li>
          {/* Ajoutez d'autres finalités spécifiques à l'activité d'Info Colab */}
          <li>Respecter nos obligations légales et réglementaires.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>4. Base légale du traitement</h2>
        <p>Le traitement de vos données personnelles est fondé sur :</p>
        <ul>
          <li>Votre **consentement** (par exemple, pour le dépôt de certains cookies si applicable).</li>
          <li>L'**exécution d'un contrat** ou de mesures précontractuelles (par exemple, pour répondre à une demande de devis ou fournir un service).</li>
          <li>Le **respect d'une obligation légale** (par exemple, pour la facturation).</li>
          <li>Notre **intérêt légitime** (par exemple, pour l'analyse de la fréquentation de notre site afin d'améliorer nos services, à condition que cela ne porte pas atteinte à vos droits et libertés).</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>5. Durée de conservation des données</h2>
        <p>
          Vos données personnelles sont conservées pendant une durée n'excédant pas celle nécessaire aux finalités pour lesquelles elles sont traitées, augmentée des délais de prescription légale. Par exemple :
        </p>
        <ul>
          <li>**Données de prospects (formulaire de contact) :** 3 ans à compter du dernier contact avec Info Colab.</li>
          <li>**Données clients :** Pendant toute la durée de la relation contractuelle, puis archivées pour la durée légale de prescription (généralement 5 ans pour les documents commerciaux et 10 ans pour les documents comptables).</li>
          <li>**Données de navigation (cookies) :** 13 mois maximum après leur premier dépôt sur le terminal de l'utilisateur.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>6. Partage des données personnelles</h2>
        <p>
          Vos données personnelles ne sont pas transmises à des acteurs commerciaux ou publicitaires.
          Elles peuvent être communiquées à :
        </p>
        <ul>
          <li>Nos **sous-traitants techniques** (hébergeur LWS, etc.) dans le cadre strict de l'exécution des services. Nous nous assurons qu'ils présentent des garanties suffisantes en matière de protection des données.</li>
          <li>Les **autorités compétentes**, sur requête et dans le cadre de procédures judiciaires ou administratives.</li>
          {/* Préciser si Info Colab transfère des données hors UE et les garanties associées, si applicable */}
        </ul>
      </section>

      <section className="privacy-section">
        <h2>7. Vos droits concernant vos données personnelles</h2>
        <p>
          Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants concernant vos données personnelles :
        </p>
        <ul>
          <li>**Droit d'accès** à vos données.</li>
          <li>**Droit de rectification** de vos données si elles sont inexactes ou incomplètes.</li>
          <li>**Droit à l'effacement** (droit à l'oubli) de vos données.</li>
          <li>**Droit à la limitation du traitement** de vos données.</li>
          <li>**Droit à la portabilité** de vos données, c'est-à-dire de les recevoir dans un format structuré et lisible par machine.</li>
          <li>**Droit d'opposition** au traitement de vos données pour des raisons légitimes.</li>
          <li>**Droit de retirer votre consentement** à tout moment (pour les traitements basés sur le consentement).</li>
          <li>**Droit d'introduire une réclamation auprès de la CNIL** (Commission Nationale de l'Informatique et des Libertés) si vous estimez que vos droits n'ont pas été respectés.</li>
        </ul>
        <p>
          Pour exercer ces droits, vous pouvez nous contacter à l'adresse e-mail : **contact@infocolab.com** ou par courrier postal à l'adresse de notre siège social : 8 Rue de l'Eglise, 78440 Drocourt, France.
        </p>
      </section>

      <section className="privacy-section">
        <h2>8. Cookies</h2>
        <p>
          Notre site utilise des **cookies** pour améliorer l'expérience utilisateur et analyser le trafic. Un cookie est un petit fichier texte stocké sur votre terminal lorsque vous visitez un site web.
        </p>
        <p>
          **Types de cookies utilisés :**
          <ul>
            <li>**Cookies strictement nécessaires :** Indispensables au bon fonctionnement du site (ex: gestion de session).</li>
            <li>**Cookies de performance/analyse :** Nous aident à comprendre comment les visiteurs interagissent avec notre site en collectant et rapportant des informations de manière anonyme (ex: Google Analytics, si utilisé).</li>
            {/* Si Info Colab utilise d'autres types de cookies, les ajouter ici (fonctionnalité, publicité) */}
          </ul>
        </p>
        <p>
          Vous pouvez configurer votre navigateur pour refuser les cookies ou être averti avant leur installation. La plupart des navigateurs vous permettent de gérer vos préférences en matière de cookies via les paramètres de "Confidentialité" ou de "Sécurité". Veuillez noter que le refus de certains cookies peut affecter la fonctionnalité du site.
        </p>
      </section>

      <section className="privacy-section">
        <h2>9. Sécurité des données</h2>
        <p>
          Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre la destruction accidentelle ou illicite, la perte, l'altération, la divulgation ou l'accès non autorisé. Cela inclut, par exemple, l'utilisation du protocole **HTTPS** pour sécuriser les communications, ainsi que les mesures de sécurité mises en place par notre hébergeur LWS.
        </p>
      </section>

      <section className="privacy-section">
        <h2>10. Modification de la politique de confidentialité</h2>
        <p>
          Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications prendront effet immédiatement après leur publication sur le site. Nous vous encourageons à consulter régulièrement cette page pour prendre connaissance des éventuelles mises à jour.
        </p>
      </section>

      <section className="privacy-section">
        <p><em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}</em></p>
      </section>

    </div>
  );
}

export default PolitiqueConfidentialitePage;